module.exports = __webpack_public_path__ + "media/images/logo2-801f41f4.png";